import React from "react";
import { motion } from "framer-motion";
import { Link2, DollarSign, Clock, CheckCircle2 } from "lucide-react";

const cards = [
  { key: "total", label: "Total Tracked", icon: Link2, color: "text-amber-400", testid: "stat-total-links", suffix: "" },
  { key: "value", label: "Total Value", icon: DollarSign, color: "text-emerald-400", testid: "stat-total-value", prefix: "$" },
  { key: "pending", label: "Pending", icon: Clock, color: "text-yellow-300", testid: "stat-pending-count" },
  { key: "completed", label: "Completed", icon: CheckCircle2, color: "text-emerald-400", testid: "stat-completed-count" },
];

export default function StatsOverview({ stats }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
      {cards.map((c, i) => {
        const Icon = c.icon;
        const raw = stats[c.key] ?? 0;
        const val = c.key === "value" ? `$${Number(raw).toFixed(2)}` : raw;
        return (
          <motion.div
            key={c.key}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.06, duration: 0.35 }}
            className="card-tactical chamfered p-4 sm:p-5 relative overflow-hidden"
            data-testid={c.testid}
          >
            <div className="flex items-center justify-between mb-3">
              <span className="label-mono">{c.label}</span>
              <Icon className={`w-4 h-4 ${c.color}`} />
            </div>
            <div className={`font-display text-3xl sm:text-4xl font-black ${c.color}`}>{val}</div>
            <div className="absolute inset-x-0 bottom-0 h-[2px] bg-gradient-to-r from-transparent via-amber-500/40 to-transparent" />
          </motion.div>
        );
      })}
    </div>
  );
}
